import { render } from "./FrontofficeCarte.vue?vue&type=template&id=37c339e8&scoped=true&ts=true"
import script from "./FrontofficeCarte.vue?vue&type=script&lang=ts"
export * from "./FrontofficeCarte.vue?vue&type=script&lang=ts"

import "./FrontofficeCarte.vue?vue&type=style&index=0&id=37c339e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c339e8"]])

export default __exports__